import { render } from "./layout-horizontal-box.vue?vue&type=template&id=59d4d05f&scoped=true"
import script from "./layout-horizontal-box.vue?vue&type=script&lang=js"
export * from "./layout-horizontal-box.vue?vue&type=script&lang=js"

import "./layout-horizontal-box.vue?vue&type=style&index=0&id=59d4d05f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d4d05f"]])

export default __exports__